<template>
  <v-sheet height="7" color="primary" width="100%"></v-sheet>
</template>

<script>
export default {
  name: 'Stylevider',
};
</script>

<style scoped>

</style>
